// Runtime configuration. Reads Vite-injected env vars (or sensible defaults).
//
// Use `||` not `??` for fallbacks: docker-compose passes unset build-args as
// empty strings, and `??` only treats null/undefined as missing.

export const NETWORK = (import.meta.env.VITE_NETWORK || "mainnet") as "mainnet" | "testnet";

export const RELAYER_URL = import.meta.env.VITE_RELAYER_URL || "https://relayer.tonadocash.com";

/**
 * Optional: TONADO RelayerRegistry contract address. When set, the dApp
 * can list every bonded relayer via the on-chain directory in addition
 * to the hardcoded RELAYER_URL above. Leave unset to keep
 * single-relayer mode (the legacy behavior).
 */
export const RELAYER_REGISTRY_ADDRESS = import.meta.env.VITE_RELAYER_REGISTRY_ADDRESS || "";

// (intentionally no toncenter URL/key here)
//
// The dApp ships ZERO toncenter API key. Every chain read goes through
// the relayer's server-side toncenter — see apps/dapp/src/lib/relayerRpc.ts
// for the typed wrappers around the relayer's /pool/..., /governance/...,
// /staking/..., /jetton/..., /registry/... endpoints. A toncenter key
// baked into VITE_* env vars would be public (anyone could view-source it)
// and exposes the dApp to quota theft + key revocation.

/**
 * Optional protocol contract addresses. The dApp loads these as defaults
 * for the veTONADO / Governance / AM / Relayers tabs; each tab also
 * accepts a user-typed override.
 */
export const TONADO_MASTER_ADDRESS = import.meta.env.VITE_TONADO_MASTER_ADDRESS || "";

export const STAKING_ADDRESS = import.meta.env.VITE_STAKING_ADDRESS || "";

export const GOVERNANCE_ADDRESS = import.meta.env.VITE_GOVERNANCE_ADDRESS || "";

export const GITHUB_URL =
  import.meta.env.VITE_GITHUB_URL || "https://github.com/tonadocash/monorepo";

export const MARKETING_URL = import.meta.env.VITE_MARKETING_URL || "https://tonadocash.com";
